// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-journal-post-template-js": () => import("/vercel/493ff508/src/templates/journal-post-template.js" /* webpackChunkName: "component---src-templates-journal-post-template-js" */),
  "component---src-templates-journal-list-template-js": () => import("/vercel/493ff508/src/templates/journal-list-template.js" /* webpackChunkName: "component---src-templates-journal-list-template-js" */),
  "component---src-pages-404-js": () => import("/vercel/493ff508/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contact-js": () => import("/vercel/493ff508/src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("/vercel/493ff508/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("/vercel/493ff508/src/pages/projects.js" /* webpackChunkName: "component---src-pages-projects-js" */)
}

